import { useEffect } from 'react'
import { useAction } from '../../api/actions/action'
import CircularProgress from '../../componentsNew/CircularProgress'
import ContainerPage from '../../componentsNew/ContainerPage'
import Typography from '../../componentsNew/Typography'
import ItemTable from '../../componentsNew/Table/ItemTable'
import HeaderTable from '../../componentsNew/Table/HeaderTable'

export function LogView() {
    const { mutate: getDataLog, data: dataLogs } = useAction()

    useEffect(() => {
        getDataLog('get_logs')
    }, [])

    function CustomNoRowsOverlay() {
        return (
            <tr className="flex items-center justify-center h-full">
                <td>Sem logs registrados</td>
            </tr>

        )
    }

    return (
        <ContainerPage titulo="Tabela de Logs">
            {dataLogs ?
                <table className="w-full table-auto flex flex-col divide-y divide-fundo-borda-grafico text-left">
                    <thead className="pb-6">
                        <tr className="flex w-full bg-neutras-grey-light rounded-lg w-full py-2 px-6 gap-4">
                            <HeaderTable className="w-3/12" >Mensagem</HeaderTable>
                            <HeaderTable className="w-3/12">Data do Log</HeaderTable>
                            <HeaderTable className="w-3/12">Exceção</HeaderTable>
                            <HeaderTable className="w-3/12">Origem</HeaderTable>

                        </tr>
                    </thead>
                    <tbody className="divide-y divide-fundo-borda-grafico w-full">
                        {dataLogs?.data?.length > 0 ? dataLogs?.data?.map(m =>
                            <tr key={m.id} className="flex w-full px-6 py-[0.625rem]">
                                <ItemTable tamanho="3/12" className="pr-4">{m?.message}</ItemTable>
                                <ItemTable tamanho="3/12" className="pr-4">{m?.date}</ItemTable>
                                <ItemTable tamanho="3/12" className="pr-4">{m?.exception}</ItemTable>
                                <ItemTable tamanho="3/12" className="pr-4">{m?.function_name}</ItemTable>
                            </tr>)
                            : CustomNoRowsOverlay()}

                    </tbody>
                </table> :
                <div className="flex gap-4 items-center justify-center">
                    <Typography className='gap-4 flex-row'>
                        <CircularProgress />
                        Carregando logs
                    </Typography>
                </div>


            }
        </ContainerPage>
    )
}
